import { render } from "./FileInput.vue?vue&type=template&id=1c8d4ce8&scoped=true&ts=true"
import script from "./FileInput.vue?vue&type=script&lang=ts"
export * from "./FileInput.vue?vue&type=script&lang=ts"

import "./FileInput.vue?vue&type=style&index=0&id=1c8d4ce8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8d4ce8"]])

export default __exports__